export type Primitive =
    | null
    | undefined
    | string
    | number
    | boolean
    | symbol
    | bigint;

export type EmptyObject = { [K in string | number]: never };

export type NonUndefined<T> = T extends undefined ? never : T;

export const Type = {

    isString: (value: unknown): value is string => typeof value === 'string',

    isEmtyObject: (value: unknown): value is EmptyObject =>
        Type.isObject(value) && !Object.keys(value).length,

    isUndefined: (val: unknown): val is undefined => val === undefined,
    isNullOrUndefined: (value: unknown): value is null | undefined => value == null,

    isObjectType: (value: unknown) => typeof value === 'object',
    isObject: <T extends object>(value: unknown): value is T =>
        !Type.isNullOrUndefined(value) &&
        !Array.isArray(value) &&
        Type.isObjectType(value) &&
        !(value instanceof Date),

    isPrimitive: (value: unknown): value is Primitive =>
        Type.isNullOrUndefined(value) || !Type.isObjectType(value)
}
